// Suspense fallback shown briefly while a lazy-loaded route chunk downloads.
// Kept intentionally minimal — most chunks are small enough that this flashes
// for only a frame or two on a warm network.

export default function LoadingFallback() {
  return (
    <div className="flex items-center justify-center py-24 text-slate-400 text-sm">Loading…</div>
  )
}
